import React from 'react';
import './SelectPaymentModal.css';

interface SelectPaymentModalProps {
  stripeLink: string;
  kassaLink: string;
  onClose: () => void;
}

const SelectPaymentModal: React.FC<SelectPaymentModalProps> = ({ stripeLink, kassaLink, onClose }) => {
  return (
    <div className="payment-modal-overlay">
      <div className="payment-modal">
        <button className="close-button" onClick={onClose}>
          ×
        </button>
        <h2 className="modal-title">Select Your payment provider:</h2>
        <p className="modal-subtitle">Choose one of available payment providers based on your location.</p>

        <div className="payment-buttons">
          <a className="payment-button stripe" href={stripeLink} target="_blank" rel="noopener noreferrer">
            <span>stripe</span>
            <small>FOR INTERNATIONAL PAYMENTS</small>
          </a>

          <a className="payment-button kassa" href={kassaLink} target="_blank" rel="noopener noreferrer">
            <span>yoo<span className="kassa-bold">kassa</span></span>
            <small>FOR RUSSIAN PAYMENTS</small>
          </a>
        </div>
      </div>
    </div>
  );
};

export default SelectPaymentModal;